import { formatLocalDate } from '../../utils/dateUtils';

export const defaultDateTickFormatter = (value) => {
  if (!value) return '';
  return formatLocalDate(value, { month: 'short', day: 'numeric' }, 'en-US');
};

export const defaultDateTooltipFormatter = (value) => {
  if (!value) return '';
  return formatLocalDate(
    value,
    { weekday: 'short', month: 'short', day: 'numeric' },
    'en-US'
  );
};

export const defaultValueFormatter = (value, name) => {
  if (value == null || Number.isNaN(value)) return '--';
  const display = Number.isInteger(value) ? value : Number(value).toFixed(1);
  return `${display}${name ? '' : ''}`;
};

export function formatRangeLabel(startValue, endValue) {
  if (!startValue || !endValue) return '';
  const start = defaultDateTickFormatter(startValue);
  const end = defaultDateTickFormatter(endValue);
  if (start === end) return start;
  return `${start} – ${end}`;
}
















